import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the type for the context data
interface AppContextType {
  companies: any;
  setCompanies: any;
  contacts: any;
  setContacts: any;
  deals: any;
  setDeals: any;
  campaigns: any;
  setCampaigns: any;
  devices: any;
  setDevices: any;
}

// Create the default context with an initial undefined value
const AppContext = createContext<AppContextType | undefined>(undefined);

// Context Provider component
export const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [companies, setCompanies] = useState([]) as any;
  const [campaigns, setCampaigns] = useState([]) as any;
  const [devices, setDevices] = useState([]) as any;

  const [contacts, setContacts] = useState([]) as any;
  const [deals, setDeals] = useState([]) as any;

  return (
    <AppContext.Provider value={{ companies, setCompanies, contacts, setContacts, deals, setDeals,campaigns, setCampaigns, devices, setDevices }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to access the context
export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
